var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrToolBar',{attrs:{"configFilter":_vm.configFilter},on:{"search":_vm.buscar},scopedSlots:_vm._u([{key:"btnSelect",fn:function(){return [_vm._t("btnSelect")]},proxy:true}],null,true)},[_c('modal'),_c('modalIndividual')],1)}
var staticRenderFns = []

export { render, staticRenderFns }